import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { TextBlock } from '../../../Atoms/Text';
import { MatrixCategory } from '../../../../types/advise';
import { categoryCount, selectionCountLabel } from './FeatureMatrixPanel.calc';
import { MatrixAddControl } from './MatrixAddControl';

export interface MatrixCategoryBlockProps {
  category: MatrixCategory;
  canEdit: boolean;
  onSelectFeature: (featureId: string, selected: boolean) => void;
}

export const MatrixCategoryBlock = ({ category, canEdit, onSelectFeature }: MatrixCategoryBlockProps) => (
  <Box
    className="mt-3"
    data-testid={`matrix-category-${category.key}`}>
    <TextBlock
      size="xs"
      weight="semibold"
      color="grey6">
      {`${category.label.toUpperCase()} · ${selectionCountLabel(categoryCount(category))}`}
    </TextBlock>
    <Box className="grid grid-cols-1 md:grid-cols-3 gap-x-4 items-center">
      {category.features.map((feature) => (
        <FormControlLabel
          key={feature.id}
          label={feature.label}
          disabled={!canEdit}
          control={
            <Checkbox
              size="small"
              checked={feature.selected}
              onChange={(event) => onSelectFeature(feature.id, event.target.checked)}
            />
          }
          slotProps={{ typography: { fontSize: 13 } }}
        />
      ))}
      {canEdit && (
        <Box>
          <MatrixAddControl label="Add custom feature" />
        </Box>
      )}
    </Box>
  </Box>
);
